import cn from "classnames"

import { CheckOutlined, WarningOutlined } from "@/icons"
import { IconTextCell } from "@/molecules/IconTextCell"

import styles from "./ViolatedCell.module.scss"

const violatedCell = (violated: boolean, noTooltip?: boolean) => {
  if (violated === false)
    return (
      <IconTextCell
        noTooltip={noTooltip}
        classes={{ container: styles.container }}
        icon={<CheckOutlined />}
        text="Not Violated"
      />
    )

  if (violated === true)
    return (
      <IconTextCell
        noTooltip={noTooltip}
        classes={{ container: cn(styles.container, styles.containerViolated) }}
        icon={<WarningOutlined />}
        text="Violated"
      />
    )

  return null
}

export const ViolatedCell = (violated: boolean) => violatedCell(violated)

// For a cell whose own popover details the violations: no tooltip repeating its text over it
export const ViolatedCellWithoutTooltip = (violated: boolean) =>
  violatedCell(violated, true)
